import { render, staticRenderFns } from "./Bulletin.vue?vue&type=template&id=530b4dba&scoped=true&"
import script from "./Bulletin.vue?vue&type=script&lang=js&"
export * from "./Bulletin.vue?vue&type=script&lang=js&"
import style0 from "./Bulletin.vue?vue&type=style&index=0&id=530b4dba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530b4dba",
  null
  
)

export default component.exports